import {GET_BALANCE} from '../types';

const initialState = {
    BTC: {
        free: "0",
        locked: "0",
        total: 0,
    },
    USDT: {
        free: "0",
        locked: "0",
        total: 0
    }
};

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_BALANCE:
            return {
                ...state,
                ...action.payload,

            };
        default:
            return state;
    }

}
